module.exports = __webpack_public_path__ + "img/HQ-OA-360V01TGU-T.a81591a1.jpg";